export const VEHICLES_RESET_STATE = 'VEHICLES_RESET_STATE';
export const VEHICLES_CURRENT_ITEM = 'VEHICLES_CURRENT_ITEM';

export const VEHICLES_REQUEST_LOADING = 'VEHICLES_REQUEST_LOADING';
export const VEHICLES_REQUEST_SUCCESS = 'VEHICLES_REQUEST_SUCCESS';
export const VEHICLES_REQUEST_FAILED = 'VEHICLES_REQUEST_FAILED';

export const VEHICLES_CURRENT_ACTION = 'VEHICLES_CURRENT_ACTION';
export const VEHICLES_RESET_ACTION = 'VEHICLES_RESET_ACTION';